module.exports = __webpack_public_path__ + "media/clicSocial.2d8d106b.mp4";